import Table from "components/DataTable/Table";
import React, { useEffect, useState } from "react";
import authHeader from "services/auth-header";
import API from "services/axios";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import PermissionsAdd from "./PermissionsAdd";
import PermissionsUpdate from "./PermissionsUpdate";
import DeleteModalButton from "components/DeleteModalBtn/DeleteModalButton";
import Spinner from "components/Spinner";

function Permissions() {
  const user = useSelector((state) => state.user.userInfo);
  /*   All States Below
   ********************************************* */
  const [permissions, setPermissions] = useState(null);

  // Modals
  const [showAddModal, setShowAddModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  // below update data is used to set a variable before moving to update component
  const [updateData, setUpdateData] = useState(null);

  const [selectedDelete, setSelectedDelete] = useState();

  const [loading, setLoading] = useState(false);

  /*   All Functions Below
   ********************************************* */

  // get All permissions
  const getAllPermissions = async () => {
    try {
      const { data } = await API.get("/permissions", {
        headers: authHeader(),
      });

      setPermissions(data);
    } catch (err) {
      alert(err.message);
    }
  };

  // Delete password Data
  const deletePermissionsData = async (id) => {
    const { data } = await API.delete("/permissions/delete/" + id, {
      headers: authHeader(),
    });
    if (data.message.type === "success") {
      getAllPermissions();
      return;
    }
  };

  // Sorting Up
  const sortUp = async (id) => {
    const index = permissions.findIndex((item) => item.id === id);
    if (index === -1) return;
    if (index === 0) return;
    if (index === permissions.length) return;

    const currentSortId = permissions[index]?.sortId;
    const currentId = permissions[index]?.id;
    const upSortId = permissions[index - 1].sortId;
    const upId = permissions[index - 1].id;
    try {
      setLoading(true);
      const { data } = await API.post(
        "/permissions/sortup",
        { currentSortId, currentId, upSortId, upId },
        { headers: authHeader() }
      );
      if (data.success) {
        getAllPermissions();
      }
      setLoading(false);
    } catch (err) {
      alert(err.message);
      setLoading(false);
    }
  };

  // Sorting Up
  const sortDown = async (id) => {
    const index = permissions.findIndex((item) => item.id === id);
    if (index === -1) return;
    if (index === permissions.length - 1) return;

    const currentSortId = permissions[index]?.sortId;
    const currentId = permissions[index]?.id;
    const downSortId = permissions[index + 1].sortId;
    const downId = permissions[index + 1].id;

    try {
      setLoading(true);
      const { data } = await API.post(
        "/permissions/sortDown",
        { currentSortId, currentId, downSortId, downId },
        { headers: authHeader() }
      );
      if (data.success) {
        getAllPermissions();
      }
      setLoading(false);
    } catch (err) {
      alert(err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    let timeout = setTimeout(() => {
      getAllPermissions();
    }, 50);
    return () => clearTimeout(timeout);
  }, []);

  /*   Table Functions below
   ********************************************* */
  const buttons = () => (
    <div className="d-flex justify-content-end ms-2">
      <button onClick={() => setShowAddModal(true)} className="btn btn-primary">
        ADD NEW
      </button>
    </div>
  );

  const table_head = ["Group", "Name", "Desc", "Main Module", "Action"];
  const table_body = (item, index) => (
    <tr key={item.id}>
      <td>{item.permGroup}</td>
      <td>{item.permName}</td>
      <td>{item.permDescription}</td>
      <td>{item.permMainModule}</td>
      <td className="table-action">
        {user?.roles === "admin" && (
          <button
            onClick={() => {
              item.sortId !== 1 && sortUp(item.id);
            }}
            className="action-icon btn"
          >
            <i className="mdi mdi-chevron-double-up"></i>
          </button>
        )}
        {user?.roles === "admin" && (
          <button
            onClick={() => {
              item.sortId !== permissions.length && sortDown(item.id);
            }}
            className="action-icon btn"
          >
            <i className="mdi mdi-chevron-double-down"></i>
          </button>
        )}
        <button className="action-icon btn">
          <i
            onClick={() => {
              setShowUpdateModal(true);
              setUpdateData(item);
            }}
            className="mdi mdi-pencil"
          ></i>
        </button>
        <div className="action-icon btn">
          <DeleteModalButton
            deleteFunc={deletePermissionsData}
            deleteParams={item.id}
            btnClass={"btn btn-sm btn-danger py-1 px-1"}
          />
        </div>
      </td>
    </tr>
  );

  return (
    <div className="row">
      <h3>Permission</h3>
      {loading && <Spinner />}
      <div className="col-12">
        <Table
          btn1={buttons}
          table_body={table_body}
          table_head={table_head}
          table_data={permissions || []}
        />

        {/*   ADD Modal
         ********************************************* */}
        <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
          <Modal.Body className="custom-shadow">
            <div>
              <PermissionsAdd
                showAddPage={setShowAddModal}
                refreshFunc={getAllPermissions}
              />
            </div>
          </Modal.Body>
        </Modal>
        {/*   Update Modal
         ********************************************* */}
        <Modal show={showUpdateModal} onHide={() => setShowUpdateModal(false)}>
          <Modal.Body className="custom-shadow">
            <div>
              <PermissionsUpdate
                data={updateData}
                showUpdatePage={setShowUpdateModal}
                refreshFunc={getAllPermissions}
              />
            </div>
          </Modal.Body>
        </Modal>
        {/*   Confirmation Modal
         ********************************************* */}

        <div
          id="danger-alert-modal"
          className="modal fade"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-sm ">
            <div className="modal-content modal-filled bg-danger">
              <div className="modal-body p-4">
                <div className="text-center">
                  <i className="ri-close-circle-line h1"></i>
                  <h4 className="mt-2">Confirm Delete!</h4>
                  <p className="mt-3">Do You want to delete ?</p>
                  <button
                    type="button"
                    className="btn btn-light my-2 mx-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-light my-2 "
                    data-bs-dismiss="modal"
                    onClick={() => {
                      deletePermissionsData(selectedDelete.id);
                    }}
                  >
                    DELETE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Permissions;
